import React, { Component } from "react";
import "./Profile.css";
import ProfileTop from "../../../Assets/img/profileTop.svg";
import User from "../../../Assets/img/user.png";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import styles from "./Profile.module.scss";
import { MdArrowBackIosNew } from "react-icons/md";
import { RiSuitcaseLine } from "react-icons/ri";
import { ImInfo } from "react-icons/im";
import { HiOutlinePhone } from "react-icons/hi";
import { RiWhatsappLine } from "react-icons/ri";
import { HiOutlineLogout } from "react-icons/hi";
import { SlGraduation } from "react-icons/sl";
import { TbFileDescription } from "react-icons/tb";
import HeaderProfile from "../../Hoc/Header.Profile";

// Wrapper برای استفاده از useNavigate در کلاس
function ProfileWrapper(props) {
  const navigate = useNavigate();
  return <Profile {...props} navigate={navigate} />;
}

class Profile extends Component {
  constructor() {
    super();
    this.state = {
      user: {},
    };
  }

  componentDidMount() {
    this.checkToken();
    this.getUser();
  }

  checkToken() {
    if (localStorage.getItem("token") === null) {
      this.props.navigate("/login");
    }
  }

  getUser() {
    const token = localStorage.getItem("token");
    if (!token) return;

    axios
      .get(`https://arianaapp.arianaapply.com/api/V1/get-user/${token}`)
      .then((response) => {
        console.log("user", response.data);
        this.setState({ user: response.data });
      })
      .catch((err) => {
        console.error(err);
        this.props.navigate("/login");
      });
  }

  logOut() {
    localStorage.removeItem("token");
    this.props.navigate("/");
  }

  render() {
    const { user } = this.state;

    // تا وقتی کاربر لود نشده، لودر نشان بده
    if (!user || !user.name) {
      return (
        <div className="spinner">
          <Loader
            type="TailSpin"
            color="rgb(236, 177, 28)"
            height={80}
            width={80}
          />
        </div>
      );
    }

    return (
      <div className={styles.profileOut}>
        <HeaderProfile title="پروفایل" />
        <div className={styles.profile}>
          <div className={styles.profileBody}>
            <img className={styles.profileTopImg} src={ProfileTop} alt="" />

            <div className={styles.ProfileCard}>
              <div className={styles.cardHeader}>
                <img src={User} alt="" />
                <h2>{user.name}</h2>
              </div>

              <div className={styles.cardBody}>
                {/* شغل‌های درخواست‌داده‌شده */}
                <Link to={`/send-resume-job/${user._id}`}>
                  <div className={styles.cardOptionImg}>
                    <RiSuitcaseLine />
                  </div>
                  <div className={styles.cardOptionText}>
                    <span>شغل های درخواست داده شده</span>
                  </div>
                  <MdArrowBackIosNew />
                </Link>

                {/* فرصت‌های تحصیلی */}
                <Link to={`/send-resume-education/${user._id}`}>
                  <div className={styles.cardOptionImg}>
                    <SlGraduation />
                  </div>
                  <div className={styles.cardOptionText}>
                    <span>فرصت های تحصیلی درخواست داده شده</span>
                  </div>
                  <MdArrowBackIosNew />
                </Link>

                {/* رزومه من */}
                <Link to={`/resume/${user._id}`}>
                  <div className={styles.cardOptionImg}>
                    <TbFileDescription />
                  </div>
                  <div className={styles.cardOptionText}>
                    <span>رزومه من</span>
                  </div>
                  <MdArrowBackIosNew />
                </Link>

                {/* درباره ما */}
                <Link to="/about-us">
                  <div className={styles.cardOptionImg}>
                    <ImInfo />
                  </div>
                  <div className={styles.cardOptionText}>
                    <span>درباره ما</span>
                  </div>
                  <MdArrowBackIosNew />
                </Link>

                {/* تماس با ما */}
                <Link to="/contact-us">
                  <div className={styles.cardOptionImg}>
                    <HiOutlinePhone />
                  </div>
                  <div className={styles.cardOptionText}>
                    <span>تماس با ما</span>
                  </div>
                  <MdArrowBackIosNew />
                </Link>

                {/* واتساپ */}
                <a href="https://wa.me/+989909170225">
                  <div className={styles.cardOptionImg}>
                    <RiWhatsappLine />
                  </div>
                  <div className={styles.cardOptionText}>
                    <span>ارتباط با ما در واتس اپ</span>
                  </div>
                  <MdArrowBackIosNew />
                </a>

                {user.role === "admissioner" && (
                  <div
                    onClick={() =>
                      this.props.navigate("/conversations", {
                        state: { userDetails: user },
                      })
                    }
                  >
                    <span>گفتگو با مشتریان</span>
                  </div>
                )}

                {user.role === "client_admission" && (
                  <div onClick={() => this.props.navigate("/about-us")}>
                    <span>گفتگو با ادمیشن</span>
                  </div>
                )}

                <div className={styles.profileBtn}>
                  <button type="button" onClick={() => this.logOut()}>
                    <HiOutlineLogout className={styles.exitImg} />
                    <h5>خروج از حساب کاربری</h5>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProfileWrapper;